import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function GuestPaymentRoute(props) {
  const { qrData } = useSelector((state) => state.fe);
  const qrDataValid = !_.isEmpty(qrData);

  return qrDataValid ? props.children : <Navigate to="/" />;
}

export default GuestPaymentRoute;
